import React, { useEffect, useState } from "react";

import { Close, WarningFilled } from "@carbon/icons-react";
import useIsMobile from "src/hooks/useIsMobile";

import "./MobileAlertStyle.css";
import "src/scss/_icons.scss";

const MobileAlert = ({ children }) => {
  const isMobile = useIsMobile();
  const [isAlertVisible, setIsAlertVisible] = useState(false); // Manages alert visibility based on isMobile, screen location, and user dismissal.

  // Handles visibility of alert whenever the isMobile variable changes
  // Alert is not visible on public application pages
  useEffect(() => {
    const currentPath = window.location.pathname;

    const excludedPatterns = [
      /^\/recruitment\/job-posts(?:\/[^/]+)?$/, // Public pages
      /^\/terms-of-service$/,
      /^\/applications\/applicant-profile\/[^/]+$/,
      /^\/applications\/applicant-profile\/[^/]+\/interview-kit\/[^/]+$/,
    ];

    const shouldShowAlert =
      isMobile &&
      !excludedPatterns.some((pattern) => pattern.test(currentPath));

    setIsAlertVisible(shouldShowAlert);
  }, [isMobile]);

  const handleDismiss = () => {
    setIsAlertVisible(false);
  };

  return (
    <>
      {isAlertVisible && (
        <div className="mobile-alert-overlay">
          <div className="mobile-alert-content">
            <Close
              className="mobile-alert-close-icon medium-icon neutral-icon clickable-icon"
              onClick={handleDismiss}
            />
            <div className="mobile-alert-text-container">
              <WarningFilled className="xxl-icon warning-icon"></WarningFilled>
              <p className="mobile-alert-text">
                This application is optimized for desktop only. For best
                experience, please switch to a desktop.
              </p>
            </div>
          </div>
        </div>
      )}

      {children}
    </>
  );
};

export default MobileAlert;
